var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"edge-top-base","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Крышки_Подложка"}},[_c('path',{staticClass:"tb-c-3",attrs:{"d":"M54,227.89a11.5,11.5,0,1,1-3.72-14.18H52a12.53,12.53,0,1,0,3.21,14.18Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }